<template>
  <v-app>
    <div class="h-100">
      <nav-vertical-drawer v-model="drawer"></nav-vertical-drawer>
      <nav-top-app-bar v-model="drawer"></nav-top-app-bar>

      <v-main style="min-height: 93.75%;">
        <nav-breadcrumbs v-if="mobile"></nav-breadcrumbs>
        <v-container class="h-100"
                     :fluid="fluidLayout">
          <slot></slot>
        </v-container>
      </v-main>

      <v-snackbar v-model="snack.open"
                  :color="snack.color"
                  :location="snack.location"
                  :timeout="snack.timeout"
                  :close-on-content-click="snack.closeOnContentClick">
        {{ snack.message }}
      </v-snackbar>

      <v-footer v-if="showFooter"
                color="background"
                class="justify-center"
                style="font-size: 14px;">
        © {{ year }} AMV Connected
        <a href="https://amv-as.no"
           title="AMV company website"
           target="_blank"
           class="ml-4">
          <img src="/Logo-eng-web-blue.png"
               alt="Logo"
               width="59"
               height="32" />
        </a>

        <a href="/contact-us"
           class="ml-4 amv-link">
          <v-icon size="small">mdi-email-outline</v-icon>
          Contact us
        </a>

      </v-footer>
      <confirm-dialog v-model="confirmDialogProps.open"
                      :on-confirm="onConfirmCallback"
                      :on-cancel="onCancelCallback"
                      :options="confirmDialogProps">
      </confirm-dialog>
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { useDisplay } from "vuetify";

const { $dayjs } = useNuxtApp();
const { mobile } = useDisplay();
const { fluidLayout, showFooter } = useLayoutOpts();
const { snack } = useAppSnack();
const { confirmDialogProps, onConfirmCallback, onCancelCallback } = useAppConfirmDialog();
useGlobalGqlSubscriptions();

const drawer = ref(true);
const year = $dayjs().year();

watch(mobile, (val) => {
  if (val) {
    drawer.value = !val;
  }
}, { immediate: true });

</script>
<style scoped>
.v-footer {
  height: 80px !important;
}
</style>

